import React, {Component} from 'react';

class IconDesc extends Component {
  render(){
    return(
      <div>
        <div className="row" >
          <div className="col-xs-6 w3-padding-16">
          <div className="icon-box">
              <div className="icon icon-accident icon-accident-dims w3-margin-right"></div>
            </div>Kecelakaan kerja
          </div>
          <div className="col-xs-6 w3-padding-16">
            <div className="icon-box">
              <div className="icon icon-heartbeat icon-heartbeat-dims w3-margin-right"></div>
            </div>Kematian
          </div>
        </div>
        <div className="row" >
          <div className="col-xs-6 w3-padding-16">
            <div className="icon-box">
              <div className="icon icon-retirement icon-retirement-dims w3-margin-right"></div>
            </div>Pensiun
          </div>
          <div className="col-xs-6 w3-padding-16">
            <div className="icon-box">
              <div className="icon icon-old-man icon-old-man-dims w3-margin-right"></div>
            </div><span>Hari tua</span>
          </div>
        </div>
      </div>
    )
  }
}

export default IconDesc;



// WEBPACK FOOTER //
// ./src/component/Home/Content/icon_desc.js